import "./App.css";
import React from "react";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/auth/Login";
import SignUp from "./components/auth/SignUp";
import ForgotPassword from "./components/auth/ForgotPassword";
import PrivateRoute from "./components/auth/PrivateRoute";
import Dashboard from "./components/template/dashboard/Dashboard";
import InvidDashboard from "./components/template/dashboard/DashboardScr";
import UserList from "./components/template/User/UserList";
import AddUser from "./components/template/User/Add";
import UserEdit from "./components/template/User/UserEdit";
import SiteUser from "./components/template/User/SiteUser";
import Pin from "./components/template/User/Pin";
import AdminPin from "./components/template/User/AdminPin";
import AddSite from "./components/template/Site/Add";
import Site from "./components/template/Site/Site";
import EditSite from "./components/template/Site/Edit";
import Lockers from "./components/template/Locker/Lockers";
import LockerView from "./components/template/Locker/LockerView";
import LockerAdd from "./components/template/Locker/LockerAdd";
import LockerEdit from "./components/template/Locker/LockerEdit";
import LockerDetail from "./components/template/Locker/LockerDetail";
import Pickups from "./components/template/Pickup/Pickups";
import PickupBook from "./components/template/Pickup/PickupBook";
import PickupDetail from "./components/template/Pickup/PickupDetail";
import PickupOrder from "./components/template/Pickup/PickupOrder";
import DepartmentUniversal from "./components/template/Pickup/DepartmentUniversal";
import PickupOrderDetail from "./components/template/Pickup/PickupOrderDetail";
import PickupExternalOrder from "./components/template/Pickup/PickupExternalOrder";
import PickupEdit from "./components/template/Pickup/PickupEdit";
import Profile from "./components/template/profile/Profile";
import EditProfile from "./components/template/profile/EditProfile";
import ResetPassword from "./components/auth/ResetPassword";

import CommunicationList from "./components/template/Communication/CommnicationList";
import EmailTemplate from "./components/template/Communication/EmailTemplate";

import TimeOutList from "./components/template/TimeOuts/List";
import TimeOutEdit from "./components/template/TimeOuts/Edit";
import TimeOutAdd from "./components/template/TimeOuts/Add";
import ManualList from "./components/template/Manual/ManualList";
import DepartmentList from "./components/template/Department/DepartmentList";
import LockerPinOpen from "./components/template/Locker/LockerPinOpen";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/" element={<SiteUser />} />
          <Route exact path="/:slug/pin" element={<Pin />} />
          <Route exact path="/:slug/department" element={<DepartmentUniversal />} />
          <Route exact path="/:slug/locker/open/:id" element={<LockerPinOpen />} />
          <Route exact path="/:slug/admin" element={<AdminPin />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/signup" element={<SignUp />} />
          <Route exact path="/forgot/password" element={<ForgotPassword />} />
          <Route exact path="/:slug/dashboard" element={<InvidDashboard />} />
          <Route
            exact
            path="/reset/password/:token"
            element={<ResetPassword />}
          />

          <Route
            exact
            path="/:slug/pickup/external/order/:id"
            element={<PickupExternalOrder />}
          />
          <Route element={<PrivateRoute />}>
            <Route exact path="/dashboard" element={<Dashboard />} />
            {/* USER ROUTES */}
            <Route exact path="/user/add" element={<AddUser />} />
            <Route exact path="/user/edit/:id" element={<UserEdit />} />
            <Route exact path="/user/list" element={<UserList />} />
            {/* SITE ROUTES */}
            <Route exact path="/site/list" element={<Site />} />
            <Route exact path="/add/site" element={<AddSite />} />
            <Route exact path="/edit/site/:id" element={<EditSite />} />
            {/* LOCKER ROUTES */}
            <Route exact path="/locker/list" element={<Lockers />} />
            <Route exact path="/locker/view" element={<LockerView />} />
            <Route exact path="/locker/add" element={<LockerAdd />} />
            <Route exact path="/locker/edit/:id" element={<LockerEdit />} />
            <Route exact path="/locker/detail/:id" element={<LockerDetail />} />
            {/* PICKUP ROUTES */}
            <Route exact path="/pickup/list" element={<Pickups />} />
            <Route exact path="/pickup/add" element={<PickupBook />} />
            <Route exact path="/pickup/detail/:id" element={<PickupDetail />} />
            <Route exact path="/pickup/order" element={<PickupOrder />} />
            <Route
              exact
              path="/pickup/order/:id"
              element={<PickupOrderDetail />}
            />
            <Route exact path="/pickup/edit/:id" element={<PickupEdit />} />
            {/* PROFILE ROUTES */}
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/profile/edit" element={<EditProfile />} />
            {/* Communication ROUTES */}
            <Route
              exact
              path="/communications/list"
              element={<CommunicationList />}
            />
            <Route
              exact
              path="/communications/add"
              element={<Navigate to="/communications/list" replace />}
            />
            <Route
              exact
              path="/communications/edit/:id"
              element={<Navigate to="/communications/list" replace />}
            />
            <Route
              exact
              path="/edit/email/template"
              element={<EmailTemplate />}
            />

            {/* TIMEOUTS ROUTES */}
            <Route exact path="/time-out/list" element={<TimeOutList />} />
            <Route exact path="/time-out/add" element={<TimeOutAdd />} />
            <Route exact path="/time-out/edit/:id" element={<TimeOutEdit />} />
            <Route exact path="/manual/list" element={<ManualList />} />
            <Route exact path="/department/list" element={<DepartmentList />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}
export default App;
